const properties = {
    appVersion : "3.2.1"
};

export default properties
